import { connect } from 'react-redux';

// components
import { InviteeWithTranslations as Invitee } from './invitee.component';
// types
import { State } from 'widgets/friends-referral/root/root.reducers';
import { IInviteeStoreProps } from './invitee.types';

const mapStateToProps = (state: State): IInviteeStoreProps => {
    return {
        softCloseMode: state.friendsReferral.campaignInfo.softCloseMode,
        invitationInfo: state.friendsReferral.invitationInfo,
        playerStats: state.friendsReferral.playerStats,
        conversion: state.friendsReferral.campaignInfo.conversion,
        dataFormat: state.config.friendsReferral?.dataFormat,
        inviteeRewardImageSrc: state.config.friendsReferral?.inviteeRewardImageSrc,
        shouldInheritStyles: state.config.shouldInheritStyles
    };
};

export default connect(mapStateToProps)(Invitee);
